var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{staticClass:"responsive-carousel",attrs:{"height":_vm.bannerHeight,"interval":_vm.interval,"arrow":_vm.arrow,"autoplay":_vm.autoplay}},_vm._l((_vm.banners),function(item){return _c('el-carousel-item',{key:item.id},[_c('div',{staticClass:"carousel-item"},[_c('img',{attrs:{"src":item.img,"alt":item.alt || '配送服务'}})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }